<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Dialog.DeleteMember"></span>
        </h3>
    </div>

    <div class="p-4 pt-0">
        <div class="lh-base" translate>Dialog.DeleteMemberWorkgroupInformation</div>

        <div class="col-12 mt-5 pt-5 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()" translate>Button.Back</button></span>
            <span class="float-end"><button type="button" class="btn btn-sm btn-danger" (click)="delete()" translate>Button.Delete</button></span>
        </div>
    </div>
</div>